"use client";

import { cn } from "@/lib/utils";

interface FilterChipsProps {
	options: string[];
	selected: string[];
	onToggle: (value: string) => void;
	counts?: Record<string, number>;
}

export function FilterChips({ options, selected, onToggle, counts }: FilterChipsProps) {
	return (
		<div className="flex flex-wrap gap-2">
			{options.map((opt) => {
				const isSelected = selected.includes(opt);
				const count = counts?.[opt];
				return (
					<button
						key={opt}
						type="button"
						onClick={() => onToggle(opt)}
						className={cn(
							"rounded-full px-4 py-2 text-sm font-medium transition-all duration-200",
							isSelected
								? "bg-primary text-primary-foreground shadow-sm"
								: "bg-muted/60 text-foreground hover:bg-muted",
						)}
					>
						{opt}
						{count != null && (
							<span
								className={cn("ml-1.5", isSelected ? "text-primary-foreground/80" : "text-muted-foreground")}
							>
								({count})
							</span>
						)}
					</button>
				);
			})}
		</div>
	);
}
